import { useContext } from "react";
import constants from "../constants";
import { getDataFromStorage } from "../util";
import useAxiosPrivate from "./useAxiosPrivate";
import AlertContext from "../context/AlertContext";
import useCommonFunctionHooks from "./useCommonFunctionHooks";
import useS3FileManagement from "./useS3FileManagement";

export default function RegistrationPageHooks() {
  const Alert = useContext(AlertContext);

  const axios = useAxiosPrivate();
  const { onMultiPartUpload } = useS3FileManagement();

  const { getCatchBlockDetails, getHeaderDetailsForAxios } =
    useCommonFunctionHooks();

  const videoConstraints = {
    width: 230,
    height: 120,
    facingMode: "user",
  };

  const handleNavigate = () => {
    Alert.setShowNotify({ show: false });

    if (localStorage.getItem("companyId")?.trim()) {
      Alert.navigate("/home");
    } else {
      Alert.navigate("/company");
    }
  };

  const handleSkip = () => {
    Alert.setShowNotify({
      show: true,
      titleSvg: "warning",
      primaryButtonFunction: handleNavigate,
      title:
        "You need to register yourself if you want to take proctored tests:",
      msg: `You've skipped this step for now, but if you want to take proctored tests, you will be asked to register before taking the 
            test. Otherwise, you cannot attend the proctored tests.`,
    });
  };

  const takePicture = async () => {
    Alert.setIsLoaded(true);

    //Change the number of pics to be taken here

    Alert.numberOfPicsToTake.current = 1;

    let picWait;

    while (Alert.countPicture.current < 1) {
      let pictureSrc = Alert.webCamRef.current.getScreenshot();

      picWait = await handleSavePicture(pictureSrc);

      if (picWait.msg === "success") {
        Alert.countPicture.current++;
      } else {
        break;
      }
    }

    if (Alert.countPicture.current === 1) {
      profileUpdate(picWait.data);
    }
  };

  const generatePickleFile = () => {
    let payload = {
      learnerid: getDataFromStorage("learnerid"),

      // batchid: Alert.batchDetails.id,
    };

    axios
      .post("node/admin/pic/model", payload, getHeaderDetailsForAxios())
      .then((res) => {
        if (res.data.resultCode !== constants.RESULT_STATUS.SUCCESS) {
          Alert.setShowNotify({
            show: true,
            title: "Info",
            msg: "Something went wrong. Please try again.",
          });
        } else {
          Alert.setRegistered(1);
          // Alert.setShowNotify({
          //   show: true,
          //   title: "Success",
          //   msg: "Successfully generated the face recognition model.",
          // });
        }
      })
      .catch((error) => {
        getCatchBlockDetails(error);
      })
      .finally(() => {
        Alert.setIsLoaded(false);
      });
  };

  const profileUpdate = (picBlob) => {
    let form = new FormData();
    let url = "node/learner/verifypic/save";

    form.append("register", "true");
    form.append("learnerid", getDataFromStorage("learnerid"));

    // form.append("batchid", localStorage.getItem("batchid"));

    if (process.env.REACT_APP_DEPLOYMENT === "LOCAL")
      form.append("images", picBlob);

    axios
      .post(url, form, getHeaderDetailsForAxios("multipart"))
      .then((res) => {
        if (res.data.resultCode === constants.RESULT_STATUS.SUCCESS) {
          Alert.setCaptureBtnHide(false);
          generatePickleFile();
        } else {
          Alert.setShowNotify({
            show: true,
            title: "Info",
            msg: res.data.msg,
          });
          Alert.setCaptureBtnHide(false);
        }
      })
      .catch((error) => {
        getCatchBlockDetails(error);
        Alert.setCaptureBtnHide(false);
      })
      .finally(() => {
        Alert.setIsLoaded(false);
      });
  };

  const b64toBlob = (dataURI) => {
    return new Promise((resolve, reject) => {
      try {
        let byteString = atob(dataURI.split(",")[1]);
        let ab = new ArrayBuffer(byteString.length);
        let ia = new Uint8Array(ab);

        for (let i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
        }

        let blobdata = new Blob([ab], { type: "image/png" });

        resolve(blobdata);
      } catch (err) {
        reject(err);
      }
    });
  };

  const handleSavePicture = async (pic) => {
    // Alert.setIsLoaded(true);

    let blob = await b64toBlob(pic);

    if (Alert.countPicture.current === 0) {
      let filePath = `Proctoring/Registration/${getDataFromStorage(
        "learnerid"
      )}/${getDataFromStorage("learnerid")}.png`;

      if (process.env.REACT_APP_DEPLOYMENT === "AWS")
        await onMultiPartUpload(filePath, blob);
    }

    let image = [pic.split(",")[1]];
    
    let payload = {
      image,
      learnerid: getDataFromStorage("learnerid"),

      // batchid: localStorage.getItem("batchid"),
    };

    let msg = await axios
      .post("node/learner/pic/register", payload, getHeaderDetailsForAxios())
      .then((res) => {
        if (res.data.resultCode !== constants.RESULT_STATUS.SUCCESS) {
          Alert.setShowNotify({
            show: true,
            title: "Info",
            msg:
              res.data.message != undefined
                ? res.data.message
                : "Something went wrong. Please try again.",
          });

          return "failure";
        } else {
          return "success";
        }
      })
      .catch((error) => {
        getCatchBlockDetails(error);
      });

    Alert.setIsLoaded(false);

    return new Promise((resolve, reject) => {
      resolve({ msg, data: blob });
    });
  };

  return { handleSkip, videoConstraints, handleNavigate, takePicture };
}
